import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $AvailableHandlingMethods = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('lg')};
`;
